import React, { useState } from 'react';
import { LayersIcon, ArrowRightIcon, BoxIcon } from 'lucide-react';
import { FluidWebModal } from './FluidWebModal';
const PoweredByFluidWeb = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <section className="w-full bg-gray-900 text-white py-[5.75rem] relative overflow-hidden" data-id="element-398">
        {/* Abstract Background */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gray-800 to-transparent opacity-50 pointer-events-none" data-id="element-399" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-400" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-401">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-402">
            <div className="lg:w-1/2" data-id="element-403">
              <div className="inline-flex items-center gap-2 bg-gray-800 border border-gray-700 rounded-full px-4 py-1.5 mb-6" data-id="element-404">
                <LayersIcon size={16} className="text-orange-400" data-id="element-405" />
                <span className="text-sm font-medium text-gray-300" data-id="element-406">
                  The Platform
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-407">
                Powered by FluidWeb
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-408">
                FluidForm is the first component built on FluidWeb — the
                platform for reliable agentic interfaces. As your needs expand
                beyond forms, FluidWeb extends the same reliability model to
                other UI building blocks like agentic tables, navigation, and
                in-app actions.
              </p>
              <ul className="space-y-4 mb-10" data-id="element-409">
                {['One foundation for reliability: schema, validation, confirmations, and control', 'Designed to support drop-in components and custom experiences'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-410">
                    <BoxIcon className="text-orange-400 mt-1 shrink-0" size={20} data-id="element-411" />
                    <span className="text-gray-300" data-id="element-412">{item}</span>
                  </li>)}
              </ul>
              <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center gap-2 text-white font-semibold hover:text-orange-400 transition-colors text-lg group" data-id="element-413">
                Learn more about FluidWeb
                <ArrowRightIcon size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-414" />
              </button>
            </div>

            <div className="lg:w-1/2 w-full" data-id="element-415">
              <div className="relative bg-gray-800 rounded-2xl border border-gray-700 p-4 sm:p-8 shadow-2xl" data-id="element-416">
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-orange-500 rounded-full blur-2xl opacity-20" data-id="element-417" />
                <div className="space-y-6" data-id="element-418">
                  <div className="flex items-center justify-between border-b border-gray-700 pb-4" data-id="element-419">
                    <div className="flex items-center gap-3" data-id="element-420">
                      <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-421" />
                      <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-422" />
                      <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-423" />
                    </div>
                    <span className="text-xs text-gray-500 font-mono" data-id="element-424">
                      fluidweb-sdk-preview
                    </span>
                  </div>
                  <div className="space-y-4 font-mono text-xs sm:text-sm text-gray-400 overflow-x-auto" data-id="element-425">
                    <div className="flex flex-wrap gap-x-2 gap-y-1 min-w-0" data-id="element-426">
                      <span className="text-purple-400" data-id="element-427">import</span>
                      <span className="text-white break-all" data-id="element-428">
                        {'{ FluidForm, AgenticTable }'}
                      </span>
                      <span className="text-purple-400" data-id="element-429">from</span>
                      <span className="text-green-400" data-id="element-430">'@fluidweb/react'</span>
                    </div>
                    <div className="pl-2 sm:pl-4 border-l-2 border-gray-700" data-id="element-431">
                      <p data-id="element-432">
                        <span className="text-blue-400" data-id="element-433">&lt;FluidForm</span>
                      </p>
                      <p className="pl-2 sm:pl-4" data-id="element-434">
                        <span className="text-yellow-400" data-id="element-435">schema</span>=
                        <span className="text-white" data-id="element-436">{'{userSchema}'}</span>
                      </p>
                      <p className="pl-2 sm:pl-4" data-id="element-437">
                        <span className="text-yellow-400" data-id="element-438">mode</span>=
                        <span className="text-green-400" data-id="element-439">"agentic"</span>
                      </p>
                      <p className="pl-2 sm:pl-4" data-id="element-440">
                        <span className="text-yellow-400" data-id="element-441">onComplete</span>=
                        <span className="text-white" data-id="element-442">{'{handleSuccess}'}</span>
                      </p>
                      <p data-id="element-443">
                        <span className="text-blue-400" data-id="element-444">/&gt;</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FluidWebModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-445" />
    </>;
};
export default PoweredByFluidWeb;